import script from "./HrMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HrMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./HrMenuItem.vue?vue&type=style&index=0&id=489500c9&lang=scss"

const __exports__ = script;

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem});qInstall(script, 'directives', {ClosePopup,Ripple});
